module.exports = __webpack_public_path__ + "img/hof_no.8cfda7a8.png";